import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

import { ConsigneesDto } from "@helper/abstraction/consignee";
import { SelfFetchOption } from "@shared/storage-popup/storage-grid/storage-grid.component";

@Component({
	selector: "app-party-popup",
	templateUrl: "./party-popup.component.html",
	styleUrls: ["./party-popup.component.scss"],
})
export class PartyPopupComponent implements OnInit {
	public formType?: number;
	public options?: SelfFetchOption<any>;
	public mode: "CREATE" | "VIEW" | "EDIT" | "SELECT" = "SELECT";
	public dataType: "STORAGES" | "PARTY" = "PARTY";
	public changeHeight = false;
	public keyMapModel?: [string, string[]];

	constructor(
		public config: DynamicDialogConfig,
		public ref: DynamicDialogRef
	) { }

	public ngOnInit(): void {
		this.setData();
	}

	public setData(): void {
		this.config.width = "490px";
		for (let k in this.config.data) {
			(this as any)[k] = this.config.data[k];
		}
		this.config.height = this.changeHeight ? this.config.header : "590px";
	}

	public close(): void {
		this.ref.close();
	}

	public addParty(party: ConsigneesDto): void {
		this.ref.close(party);
	}
}
